import { interpolate } from "gsap/all";
import yhtp from "../assets/img/yhtp.jpeg";
export const alertMapQy = (item)=>{
      const imformsg = `<div class="input-card content-window-card">
          <div class="title-name-y">
              ${item.name}
          </div>
          <div class="title-count">
            <div class="t-iten">
              <span>主要负责人：</span>
                ${item.kw0}
            </div>
              <div class="t-iten">
              <span>联系电话：</span>
                ${item.kw1 ? item.kw1 : "无"}
            </div>
             <div class="t-iten">
              <span>提交隐患数据：</span>
              123
            </div>
             <div class="t-iten">
              <span>最近提交时间：</span>
              2021-10-17
            </div>
             <div class="t-iten">
              <span>燃气行业负责人：</span>
              张明 13749373947
            </div>
            <div class="t-iten">
              <span>大型公共场所负责人：</span>
              钱枫 18237493842
            </div>
            <div class="t-iten">
              <span>交通安全负责人：</span>
              张启山 18828374952
            </div>
            <div class="t-iten">
              <span>群租楼负责人：</span>
              张起灵 18237493842
            </div><div class="t-iten">
              <span>仓储物流负责人：</span>
              赵忠敏 18237493842
            </div>
            <div class="t-iten">
              <span>三防隐患负责人：</span>
              符曼玉 18237493842
            </div>
            <div class="t-iten">
              <span>工贸行业负责人：</span>
              罗新明 18237493842
            </div>
            <div class="t-iten">
              <span>城市建设负责人：</span>
              陈曦 18237493842
            </div>
            <div class="t-iten">
              <span>危险废弃物负责人：</span>
              符发起 18237493842
            </div>
          </div>
        </div>`;
      return imformsg;
    };
export const alertMap=(item) =>{
      let photo = [];
      if (item.photo) {
        const listphoto = JSON.parse(item.photo)
        for(let i =0;i<listphoto.length;i++){
          photo.push(szblMCom.urlPrex + listphoto[i])
        }
      } else {
        photo = [yhtp];
      }
      let pTem = photo.map(item=>{
        return `<img style="margin-left:8px" src="${item}" />`
      }).join('')
      const imformsg = `
      <div class="input-card content-window-card newcount">
          <div class="title-name-y">
              ${item.name}
          </div>
          <div class="title-count">
            <div class="t-iten">
              <span>主要负责人：</span>
                ${item.kw0}
            </div>
              <div class="t-iten">
              <span>联系电话：</span>
                ${item.kw1 ? item.kw1 : "无"}
            </div>
             <div class="t-iten">
              <span>详细地址：</span>
              ${item.address}
            </div>
            <div class="t-iten">
              <span>行业类型：</span>
              ${item.kw7}
            </div>
             <div class="t-iten">
              <span>隐患描述及图片：</span>
              <div class="t-iten-remark">
                <div class="mess">
                ${item.createtime}
                  ${item.htmldata}
                </div>
                 ${pTem}
              </div>
            </div>
              <div class="t-iten">
              <span>整改措施：</span>
              ${item.kw8}
            </div>
             <div class="t-iten">
              <span>整改期限：</span>
              ${item.kw2}
            </div>
              <div class="t-iten">
              <span>整改状态：</span>
              <span class="zt" :class="${{ztut:item.status==1}}" v-if="${item.status == 2}"> ${
        item.status == 2 ? "已整改" : "整改中"
      }</span>
            </div>

          </div>
        </div>`;
                  
            //   <div class="t-iten">
            //   <span>整改进度：</span>
            //   ${item.jsondata}
            // </div> 
        // <div class="t-iten imglist">
            //   <span>现场图片：</span>
            //   <img src="${photo}" />
            // </div>
      return imformsg;
    };
    //  <span class="lsyh" @click="moreQy" v-if="${(qydata.oneStatus + qydata.twoStatus) != 0}">历史隐患</span>
export const qiyeMap =  (item,qydata)=>{
      const imformsg = `<div class="input-card content-window-card">
          <div class="title-name-y">
              ${item.name}
          </div>
          <div class="title-count">
            <div class="t-iten">
              <span>主要负责人：</span>
                ${item.kw0}
            </div>
            <div class="t-iten">
              <span>联系电话：</span>
                ${item.kw1 ? item.kw1 : "无"}
            </div>
            <div class="t-iten">
              <span>行业类型：</span>
                ${item.kw7}
            </div>
             <div class="t-iten">
              <span>详细地址：</span>
                ${item.address}
            </div>
             <div class="t-iten click"  @click="moreQy">
              <span>发生隐患数：</span>
              <span>${qydata.oneStatus + qydata.twoStatus}</span>
              <span class="lsyh">历史隐患</span>
            </div>
            <div class="t-iten">
              <span>已整改隐患数：</span>
              ${qydata.twoStatus}
            </div>
            <div class="t-iten">
              <span>未整改隐患数：</span>
              ${qydata.oneStatus}
            </div>
          </div>
        </div>`;
      return imformsg;
    };
export const alertMapJr = (item)=>{
      const imformsg = `<div class="input-card content-window-card">
          <div class="title-name-y">
              ${item.name}
          </div>
          <div class="title-count">
            <div class="t-iten">
              <span>所属镇：</span>
                ${item.kw0}
            </div>
              <div class="t-iten">
              <span>区领导：</span>
                ${item.kw1}
            </div>
             <div class="t-iten">
              <span>机关单位：</span>
              ${item.kw2}
            </div>
             <div class="t-iten">
              <span>镇街领导</span>
             ${item.kw3}
            </div>
             <div class="t-iten">
              <span>镇街干部：</span>
              ${item.kw4}
            </div>
            <div class="t-iten">
              <span>两委干部：</span>
              ${item.kw5}
            </div>
            <div class="t-iten">
              <span>网格员：</span>
              ${item.kw6}
            </div>
            <div class="t-iten">
              <span>城管员：</span>
              ${item.kw7}
            </div>
            <div class="t-iten">
              <span>民警联防：</span>
              ${item.kw8}
            </div>
            <div class="t-iten">
              <span>自愿者等辅助力量：</span>
             ${item.kw9}
            </div>
            <div class="t-iten">
              <span>时间节点：</span>
              ${item.kw10}
            </div>
            <div class="t-iten">
              <span>备注：</span>
              ${item.kw11}
            </div>
          </div>
        </div>`;
      return imformsg;
    };
